import { updater } from "../../utils/updater.js";
import logger from "../../utils/logger.js";
import apiRequest from "../../utils/ApiRequest/apiRequest.js";

// AddComment - params:
//         long Parent (id)
//         long RelevantFile  (id)
//         string Content
//         string UserName
//         long UserId
//         long MailId

// GetAllComments - params: long mailId

// GetComment -params: long commentId

// UpdateComment - params:
//         long Id
//         long Parent
//         long RelevantFile
//         string Content
//         string UserName
//         long UserId
//         long MailId

// DeleteComment - params: long commentId

const commentsFactoryErrors = {
  "rate limit": "add-comment-rate-limit-error",
};

const getRequestError = (data) => {
  let error = data;
  try {
    const parsedError = JSON.parse(data);

    if (typeof parsedError === "object" && "message" in parsedError) {
      Object.entries(commentsFactoryErrors).forEach(([key, val]) => {
        if (data?.toLowerCase()?.includes(key)) error = val;
      });
    }
  } catch (e) {}

  return error;
};

const getTime = () => {
  const timeNow = new Date();
  const saveTime = timeNow.toJSON();
  return saveTime;
};

const commentFactory = ({ state, setState }) => {
  const updateState = updater(setState);

  // ------- VIEW SECTION ------------ //
  const fetchCommentsData = async (mailId) => {
    const response = await apiRequest("Comments", "GetAllComments", {
      mailId: mailId,
    });

    if (response.status === "success") {
      updateState((draft) => {
        draft.data = response.data;
      });
    } else {
      updateState((draft) => {
        draft.error = getRequestError(response.data);
      });
      logger("commentFactory", "fetchCommentsData", response.data);
    }
  };

  const getAllCommentsData = () => state.data;
  const getFileCommentsList = (fileId) => {
    return state.data
      ? Object.keys(state.data).filter(
          (id) => state.data[id].RelevantFile == fileId
        )
      : [];
  };
  const getError = () => state.error;
  const setError = (val) => {
    updateState((draft) => {
      draft.error = val;
    });
  };

  const editComment = async ({ id, content, mailId, recaptchaResponse }) => {
    const response = await apiRequest(
      "Comments",
      "UpdateComment",
      {
        MailId: mailId,
        Id: id,
        Content: content,
        recaptchaResponse,
        // captchaServiceName: "cloudflare",
      },
      "POST"
    );
    if (response.status === "success") {
      updateState((draft) => {
        draft.data[id].Content = content;
        draft.data[id].Updated = getTime();
      });
      window.dataLayer.push({
        event: "editComment",
        commentType: state.data[id].RelevantFile ? "single" : "mail",
      });
    } else {
      updateState((draft) => {
        draft.error = getRequestError(response.data);
      });
      logger("commentFactory", "fetchCommentsData", response.data);
    }
  };

  const addComment = async ({
    parent,
    content,
    relevantFile,
    mailId,
    reupload = false,
    recaptchaResponse,
  }) => {
    const response = await apiRequest(
      "Comments",
      "AddComment",
      {
        Parent: parent,
        RelevantFile: relevantFile,
        Content: content,
        MailId: mailId,
        Reupload: reupload,
        recaptchaResponse,
        // captchaServiceName: "cloudflare",
      },
      "POST"
    );
    if (response.status === "success") {
      // add comment issue with reupload
      // if (!state?.data?.[response?.data?.Id]) return;
      updateState((draft) => {
        draft.data[response.data.Id] = {
          Id: response.data.Id,
          Created: response.data.Created,
          RelevantFile: response.data.RelevantFile,
          Updated: null,
          RelevantFileModel: response.data.RelevantFileModel,
          Parent: response.data.Parent,
          Content: response.data.Content,
          UserId: response.data.UserId,
          UserName: response.data.UserName,
          UserAvatar: response.data.UserAvatar,
        };
      });
    } else {
      updateState((draft) => {
        draft.error = getRequestError(response.data);
      });
      logger("commentFactory", "fetchCommentsData", response.data);
    }
  };

  const deleteComment = async (commentId) => {
    const hasChildren = Object.keys(state.data).some(
      (id) => state.data[id].Parent === commentId
    );
    const response = await apiRequest(
      "Comments",
      "DeleteComment",
      {
        Id: parseInt(commentId),
        HasChildren: hasChildren,
      },
      "POST"
    );
    if (response.status === "success") {
      //checking if this comment has children-comments, so we need delete it too
      hasChildren &&
        Object.keys(state.data).map(
          (id) =>
            state.data[id].Parent === commentId &&
            updateState((draft) => {
              delete draft.data[commentId];
            })
        );
      updateState((draft) => {
        delete draft.data[commentId];
      });
    } else {
      updateState((draft) => {
        draft.error = getRequestError(response.data);
      });
      logger("commentFactory", "fetchCommentsData", response.data);
    }
  };

  return {
    fetchCommentsData,
    getError,
    setError,
    getAllCommentsData,
    getFileCommentsList,
    addComment,
    editComment,
    deleteComment,
  };
};

export default commentFactory;
